export default __webpack_public_path__ + "static/media/03__o_0.da6c3ccc.jpg";